// 页面三级权限
import { mapState } from 'vuex'

export default {
    data() {
        return {
            operations: [],
            noChildMunuList: [""]
        }
    },
    created() {
        this.getOperation()
    },
    computed: {
        ...mapState(['operationList'])
    },
    methods: {
        getOperation() {
            const { meta } = this.$route
            console.log(meta)
            this.operationList.forEach(item => {
                if (meta.length >= 1) {
                    if (!this.noChildMunuList.includes(item.name) && meta[meta.length - 1].name === item.name) {
                        this.operations = item.operations
                        console.log(111)
                    } else if (this.noChildMunuList.includes(item.name) && meta[0].name === item.name) {
                        this.operations = item.operations
                        console.log(222)
                    }
                }
            })
        }
    }
}
